module.exports = __webpack_public_path__ + "img/skull_17_bj.e5b386a3.png";